import {createAction} from "redux-act";
import {IError} from "modules/types";
import {ModalType} from "modules/reducers";

export const showErrorModal = createAction<IError>();
export const hideErrorModal = createAction();

export const showSuccessModal = createAction<string>();
export const hideSuccessModal = createAction();

/**
 *  If a modal requires additional parameters,
 *  then you should use a custom flow for it.
 *  Create separate actions, selectors and handlers
 */
export const showModal = createAction<ModalType>();
export const hideModal = createAction<ModalType>();
